<template>
	<div class="menus-wrap">
		<head-info></head-info>
		<div class="relative-wrap" style="width:1000px">
			<div class="photo"><img v-if="info.photo" :src="info.photo + '?_=' + new Date().getTime()" alt="" /></div>
			<el-descriptions :column="2" title="缴费确认" border>
				<el-descriptions-item label="姓名">{{ info.name }}</el-descriptions-item>
				<el-descriptions-item
					:labelStyle="{ width: '0', backgroundColor: '#fff', border: '1px solid transparent' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5' }"
				></el-descriptions-item>
				<el-descriptions-item label="身份证号">{{ info.card_id || '-' }}</el-descriptions-item>
				<el-descriptions-item
					:labelStyle="{ width: '0', backgroundColor: '#fff', border: '1px solid transparent' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5' }"
				></el-descriptions-item>
				<el-descriptions-item label="性别">{{ info.gender && info.gender === 1 ? '男' : info.gender && info.gender === 2 ? '女' : '-' }}</el-descriptions-item>
				<el-descriptions-item
					:labelStyle="{ width: '0', backgroundColor: '#fff', border: '1px solid transparent' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5' }"
				></el-descriptions-item>
				<el-descriptions-item label="报名方式">网上报名</el-descriptions-item>
				<el-descriptions-item
					:labelStyle="{ width: '0', backgroundColor: '#fff', border: '1px solid transparent', borderBottomColor: '#EBEEF5' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5', borderBottomColor: '#EBEEF5' }"
				></el-descriptions-item>
				<el-descriptions-item label="报名序号" :span="2">{{ info.serial_id || '-' }}</el-descriptions-item>
				<el-descriptions-item v-if="info.category_name" label="岗位类别" :span="2">{{ info.category_name || '-' }}</el-descriptions-item>
				<el-descriptions-item label="报考单位" :span="2">{{ info.department || '-' }}</el-descriptions-item>
				<el-descriptions-item label="报考岗位" :span="2">{{ info.position || '-' }}</el-descriptions-item>
				<el-descriptions-item v-if="info.classify" label="考试类别" :span="2">{{ info.classify }}</el-descriptions-item>
				<el-descriptions-item label="报考科目" :span="2">
					<template v-if="info.subject && info.subject.length">
						<p v-for="item in info.subject">{{ item.subject_name }}：{{ item.amount }}元</p>
					</template>
					<template v-else>
						-
					</template>
				</el-descriptions-item>
				<el-descriptions-item label="合计" :span="2">
					<!--<span style="color: red;">{{ subject.reduce((pre, cur) => parseFloat(pre + cur.amount).toFixed(2),0) }}元</span>-->
					<span style="color: red;">{{ subject.reduce((pre, cur) => pre + +cur.amount,0) }}元</span>
				</el-descriptions-item>
			</el-descriptions>
		</div>
		<el-button v-if="info.is_pay === 1 && payment.alipay_app_id" type="primary" @click="handlePay(2)">立即支付（支付宝）</el-button>
		<el-button v-if="info.is_pay === 1 && payment.yeepay_app_id" type="primary" @click="handlePay(3)">立即支付（易宝）</el-button>
		<el-button v-else-if="info.is_pay === 2" type="success">已缴费</el-button>
		<el-button v-else-if="info.is_pay === 3" type="success">已减免</el-button>
		<el-button v-else-if="info.is_pay === 4" type="success">已确认</el-button>
		<el-button v-else-if="info.is_pay === 5" type="success">申请退费</el-button>
		<el-button v-else-if="info.is_pay === 0" type="success">已退费</el-button>
		<div id="rcorners1" style="width:900px">
			<p class="tip">缴费注意事项：</p>
			<p class="tip">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、订单有效期15分钟，另缴费截止时订单即失效，请勿在订单快过期时缴费，避免缴费不能进入指定收款账户导致造成缴费失败！</p>
			<p class="tip">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、支付完成后请牢记支付订单号及流水号以便查验！</p>
			<p class="tip">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、<span v-if="payment.yeepay_app_id">支持银行卡快捷支付和网银支付，易宝支付缴费扣款后没有改变缴费状态可先拨打易宝客服电话（95070）咨询扣款是否进入收款账户，如果没有，则让易宝处理退款，再重新缴费。</span><span v-if="payment.alipay_app_id">支付宝支付缴费扣款后没有改变缴费状态可先拨打支付宝客服电话（95188）咨询扣款是否进入收款账户，如果没有，则让支付宝处理退款，再重新缴费。</span></p>
			<p class="tip">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、如支付成功并扣款，但刷新后没有改变缴费状态为“已缴费”，请拨打考试考务电话或技术咨询电话咨询缴费情况。</p>
		</div>
	</div>
</template>

<script>
import QRCode from 'qrcodejs2'; // 引入qrcode
import HeadInfo from '@/components/HeadInfo';
import store from '@/store';
import { Message } from 'element-ui';
import { reqGetPayCandidateInfo, reqGetPayment } from '@/api';
import {mapGetters,mapState} from "vuex";
export default {
	components: {
		HeadInfo
	},
	data() {
		return {
			dialogVisible: false,
			status: false,
			info: {
				payment: {
					alipay_app_id: null,
					wechat_app_id: null,
					yeepay_app_id: null
				}
			},
			wechatShow: false
		};
	},
	computed: {
		subject() {
			return this.info.subject || [];
		},
		...mapState({
			examination_id: state => state.system.examInfo.examination_id,
			payment: state => state.system.payment,
		}),
		...mapGetters('user',['GET_USER_INFO']),
	},
	beforeRouteEnter(to, form, next) {
		reqGetPayCandidateInfo().then(res => {
			if (res.data.pay_open) {
				next(vm => {
					vm.info = vm.GET_USER_INFO;
					Object.assign(vm.info, res.data);
				});
				
			} else {
				Message.info('缴费时间已过');
				next(false);
			}
		});

	},
	methods: {
		handleClose() {
			this.dialogVisible = false;
		},
		close() {
			this.wechatShow = false;
		},
		qrcode(text) {
			document.getElementById('qrcode').innerHTML = ''; //清除上一次生成的二维码，防止刷新生成多个二维码
			let qrcode = new QRCode('qrcode', {
				width: 200, //二维码宽度
				height: 200, //二维码高度
				text, // 二维码内容
				colorDark: '#000',
				colorLight: '#fff'
			});
		},
		// 确认支付
		handlePay(payment_type) {
			switch (payment_type) {
				case 1: // 微信支付
					reqGetPayment({ payment_type, examination_id: this.examination_id }).then(res => {
						this.wechatShow = true;
						this.$nextTick(() => {
							this.qrcode(res.data.code_url);
						});
					});
					break;
				case 2: // 支付宝支付
					reqGetPayment({ payment_type, examination_id: this.examination_id }).then(res => {
						window.open(res.data, '_self');
						//this.$router.push('/form');
						/*const div = document.createElement('div');
						div.innerHTML = res.data;
						document.body.appendChild(div);
						document.getElementById('alipaysubmit').setAttribute('target', '_blank');
						document.forms[0].submit(); //重要，这个才是点击跳页面的核心
						this.$router.push('/form');*/
						// setTimeout(()=>{

						// },2000);
					});
					break;
				case 3: // 易宝支付
					reqGetPayment({ payment_type, examination_id: this.examination_id }).then(res => {
						window.open(res.data, '_self');
						//this.$router.push('/form');
					});
					break;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/color.scss';

.Qrcode {
	width: 100%;
	height: 250px;
}

.share {
	margin-left: auto;
	margin-right: auto;
	width: 200px;
	margin-top: 25px;
	margin-bottom: 25px;
}

.flex {
	display: flex;
	align-items: center;
	justify-content: space-around;
	> div {
		display: flex;
		flex-direction: column;
		align-items: center;
		cursor: pointer;
		span {
			font-size: 14px;
			color: #333;
			margin-top: 15px;
		}
	}
}

.menus-wrap {
	display: flex;
	flex-direction: column;
	align-items: center;
	.el-table {
		margin-top: 50px;
	}
	.el-button {
		margin: 30px auto;
	}
	.tip {
		font-size: 24px;
		font-weight: bold;
		color: #ff6f72;
		text-align: left;
	}
}

	#rcorners1 {
	  border-radius: 25px;
	  border: 2px solid #2461ed;
	  background: #e3ebfd;
	  padding: 20px;  
	}
.relative-wrap {
	position: relative;
	margin: 15px auto 0;
	width: 800px;
	.photo {
		width: 150px;
		height: 150px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 135px;
		right: 116px;
		transform: translate(50%, -50%);

		img {
			max-width: 150px;
			max-height: 150px;
			object-fit: cover;
		}
	}
	::v-deep.el-descriptions {
		padding: 0 20px;
		.el-descriptions__header {
			margin: 0;
			padding: 10px 0;
			justify-content: center;
			background-color: $--color-primary;
			color: #ffffff;
			.el-descriptions__title {
				font-weight: 500;
			}
		}
		.el-descriptions__body {
			.el-descriptions__table .el-descriptions-item__cell {
				line-height: 32px;
			}
			th,
			td {
				padding-left: 30px;
			}
		}
	}
}
</style>
